import React from 'react';
import styles from './progress-bar.css';

function ProgessBar() {
  return (
    <div className={styles.progressBar}>
      <div className={styles.indeterminate} />
    </div>
  );
}
export default ProgessBar;
